//
// Module for the Multi-Factor Authentication Challenge page
//
rs.module("framework/content/mfa/mfachallenge",

    [

    ],

    function () {

        // Initialize the module
        function initialize(jsSelectors) {

            var cannotAccessLink = $.js(jsSelectors.cannotAccess, { required: false, multiple: true});
            var contactLink = $.js(jsSelectors.contactUs, { required: false, multiple: true });

            // show the cannot access link
            cannotAccessLink.on("click", function () {
                cannotAccessLink.hide();
                contactLink.show();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);
